export default __webpack_public_path__ + "static/media/notify-close.473f834d.svg";